import { useState, useContext, createContext, FC, ReactNode } from 'react';

// MapView type with center and zoom
export type MapView = {
  center: { lat: number; lng: number };
  zoom: number;
};

// MapContextType with mapView and setter
export type MapContextType = {
  mapView: MapView | null;
  setMapView: (view: MapView | null) => void;
};

// MapContext with default value
export const MapContext = createContext<MapContextType>({
  mapView: null,
  setMapView: () => null
});

// Hook to access MapContext
export function useMapView(): MapContextType {
  return useContext(MapContext);
}

// Provider for MapContext
export const MapProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [mapView, setMapView] = useState<MapView | null>(null);
  return <MapContext.Provider value={{ mapView, setMapView }}>{children}</MapContext.Provider>;
};
